export const TerminalCommand = {
    'SDATE?': 'Запрос времени и даты на z3k-устройстве',
    'GETALLSTATES?': 'Запросить всех актуальных состояний z3k-устройства',
    'LOGPAS?': 'Проверка логина и пароля',
    'gsm?': 'Получение мощности GSM-сигнала',
    'DIAL=': ' Выполнение тестового дозвона на номер +71234...',
    'SMS=': 'Выполнение тестовой отправки СМС на номер +71234... (между номером и текстом должен быть пробел)',
    'POWER?': 'Получение напряжения питания',
    'IPA?': 'Проверка IP-адреса сервера',
    'IPP?': 'Проверка IP-порта сервера',
    Restart: 'Перезагрузка терминала',
    '#S15=1': 'Принять изменения и перечитать конфиг',
    '#P87=0': 'Отключить все логи',
    'time?': 'Запрос времени на устройстве',
    'date?': 'Запрос даты на устройстве',
};
export const DifferentTerminalCommand = {
    'IPA=': 'Установка IP-адреса сервера',
    'IPP=': 'Установка IP-порта сервера',
    TERMn: 'Получение температуры термодатчика n',
    TMSETCLR: 'Очистка в устройстве цифровых термодатчиков и ТМ ключей',
    TMSET: 'Включение режима добавления цифровых термодатчиков и ТМ ключей',
    '#S54': 'Серийный номер (с версии профиля 217)',
    '#S62': 'Информации о состоянии системы, диагностики двигателя (с версии профиля 240)',
    '#S8': 'Телефонные номера с разрешенным доступом по смс (?-спросить, =-задать)',
    ReConnecT: 'Принудительное переподключение терминала после команд LOGPAS= IPA= IPP=',
    'GPS?': 'Получение информации о местоположении',
    'INPn?': 'Получение информации о напряжении на входе n. Возвращает два значения напряжения в вольтах х 100. Реальное и нормированное',
    dataclr: 'Очистка памяти данных терминала',
    'LOGPAS=': 'Установка логина и пароля. Логин и пароль через пробел (IMEI *) после этой команды нужно отправить Restart ',
    'GADR=': 'Установка адреса (номера) терминала. Внимание!  Номера термина лов всегда начинаются с 5-го номера',
    'GADR?': 'Проверка адреса терминала',
    'APN=': 'Установка точки доступа. Если требуется имя пользователя и пароль, то они пишутся без пробелов через запятую (По умолчанию APN=internet)',
    'APN?': 'Проверка точки доступа',
    '#P133': 'Автосъём трубки при дозвоне на терминал (0-выключить, 1-включить)',
    '#P149': 'Запрет использования ДУТ с CAN шины (0-выключен, 1-запрет включен)',
    '#P175': 'Запрет использования акселерометра (0-выключен, 1-запрет включен)',
    '#P123 … #P132': 'Режим работы входа 1 … 10 (0-выключение;  1-медленный счётчик;  2-быстрый счётчик;  3-тревожная кнопка;  4-зажигание;  5-ДУТ2;  6-аналоговый вход;  7-расходомер;  8-ДУТ3;  9-ДУТ4;  10-ДУТ5;  11-ДУТ1)',
    '#P5': 'Таймаут переподключения с момента подключения (сек) Домашняя сеть (При задании параметра =0 функция будет запрещена)',
    '#P6': 'Таймаут переподключения после пропадания связи (сек) Домашняя сеть.',
    '#P143': 'Таймаут переподключения с момента подключения (сек) Роуминг свой (При задании параметра =0 функция будет запрещена)',
    '#P144': 'Таймаут переподключения после пропадания связи (сек) Роуминг свой.',
    '#P145': 'Таймаут переподключения с момента подключения (сек) Роуминг чужой (При задании параметра =0 функция будет запрещена)',
    '#P146': 'Таймаут переподключения после пропадания связи (сек) Роуминг чужой.',
    '#P230': 'Настройка разрешения снимков JPG камеры по событиям (Значения 0,1,2)',
    '#P181': 'Синхронизация часов по GPS (1 - включена, 0 - выключена)',
    '#P167 ': 'Зажигание по бортовой сети, по умолчанию включено = 1 (0-выключение)',
    '#P168': 'Порог напряжения для зажигания по бортовой сети, по умолчанию =0 автоматический режим если не ноль то значение порога х0,1в',
    '#P150=1': 'Протокол Виалон (0-Отключение, 1-Включение)',
    '#P173?': 'Запрос IMEI',
    '#P174=1': 'Запись ДУТ при выключенном зажигании',
    'V?': 'Текущая скорость',
    'T?': 'Текущие обороты двигателя',
    'G?': 'Текущие географические координаты',
    'U?': 'Текущее напряжение с ДУТ',
    'U_2?': 'Текущее напряжение с ДУТ2',
    'U_3?': 'Текущее напряжение с ДУТ3',
    'U_4?': 'Текущее напряжение с ДУТ4',
    'U_5?': 'Текущее напряжение с ДУТ5',
};
